import { ImageAsset } from '@common/model/resource/image';

export type NextImage = {
  src: string;
  width: number;
  height: number;
  blurHeight?: number;
  blurWidth?: number;
  blurDataURL?: string;
};

export const isNextImage = (data: unknown): data is NextImage =>
  typeof data === 'object' &&
  data !== null &&
  typeof data['src'] === 'string' &&
  typeof data['width'] === 'number' &&
  typeof data['height'] === 'number';

export const nextToAsset = (data: NextImage): ImageAsset => ({
  base: data,
});
